import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import { useState } from "react";

export default function ListViewHeaderSort({ title, code, sortBy, setSortBy, sortType, setSortType }) {
	const [isHovered, setIsHovered] = useState(false);
	return (
		<div
			style={{
				color: `${sortBy == `${code}` ? "rgb(234,97,28)" : "black"}`,
				display: "flex",
				justifyContent: "center",
			}}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			<ChevronUpIcon
				visibility={sortBy == `${code}` || (sortBy != `${code}` && isHovered) ? "visible" : "hidden"}
				style={{
					height: "1.5em",
					cursor: "pointer",
					position: "relative",
					top: `${sortType == "asc" || (isHovered && sortBy != code) ? "-1px" : "-2px"}`,
					transform: `${sortType == "asc" || (isHovered && sortBy != code) ? "rotateX(0deg)" : "rotateX(180deg)"}`,
				}}
				onClick={() => {
					setSortBy(code);
					if (sortBy != code) return setSortType("desc");
					setSortType(sortType == "asc" ? "desc" : "asc");
				}}
			/>
			<div
				style={{ cursor: "pointer", userSelect: "none", marginRight: "1em" }}
				onClick={() => {
					setSortBy(`${code}`);
					if (sortBy == `${code}`) return setSortType(sortType == "asc" ? "desc" : "asc");
					setSortType("asc");
				}}
			>
				{title}
			</div>
		</div>
	);
}
